"use client"

import { useSyncStatesWithSocket } from "@utils/useSyncStatesWithSockets"
import { DefaultLoadingManager } from "three"

type Props = {
  totalItems: number
  logAssets: boolean
  onProgress: (progress: number) => void
  onLoaded: () => void
  device: "tablet" | "screen"
}

const HandleLoadingProgress = ({
  totalItems,
  logAssets,
  onProgress,
  onLoaded,
  device,
}) => {
  const { syncStatesWithSocket: syncState } = useSyncStatesWithSocket()

  DefaultLoadingManager.onError = function (url) {
    console.log("There was an error loading " + url)
  }

  DefaultLoadingManager.onProgress = function (url, itemsLoaded, totalAssets) {
    const progress = (itemsLoaded / totalItems) * 100
    if (progress <= 100) {
      syncState({ loadProgress: progress })
      if (progress === 100) {
        syncState({ [`${device}Loaded`]: true })
      }
      onProgress(progress)
    }
  }

  return null
}

export default HandleLoadingProgress
